// @ts-nocheck
import React from 'react';
import { ImageIcon } from 'pages/Forms/RegisterForm/CustomFormBuilder/config/constantSvg';
import { Box } from '@mui/material';
import { useAttachmentStyles } from '../style';
import { imageFormats } from '../constants';
import ImageActions from './ImageActions';

const ImageAttachment = ({ imageAttach, setImageAttach, handleDirty }) => {
  const classes = useAttachmentStyles();
  const renderPhotos = () =>
    imageAttach
      ?.filter((photo) =>
        imageFormats.includes(photo?.name?.split('.').pop()?.toLowerCase()),
      )
      .map((photo) => (
        <Box key={photo?.id} className={classes.attachmentsContainer}>
          <Box>
            <Box className={classes.attachmentIcon}>
              <ImageIcon />
            </Box>
            <img
              src={photo?.file}
              alt=""
              key={photo}
              className={classes.attachment}
            />
            <ImageActions
              photo={photo}
              setImageAttach={setImageAttach}
              imageAttach={imageAttach}
              classes={classes}
              handleDirty={handleDirty}
            />
          </Box>
        </Box>
      ));
  return renderPhotos();
};

export default ImageAttachment;
